import api from '../services/api';
import { rotulosTrasSubir } from './rotulosFotos';

// Sube una foto que todavía es data URL y devuelve el nombre de archivo que guarda el backend.
// Si ya es un nombre (o una URL), la devuelve igual.
// 27-oct-2026: cache en memoria por foto. Las fotos se empiezan a subir en segundo plano apenas el
// técnico marca un equipo como listo; al tocar "Guardar" se reusa esa subida (terminada o en curso)
// en vez de mandarla de nuevo. La que falla sale de la cache y se reintenta al guardar.
const _subidas = new Map();
export function subirFoto(src, prefijo = 'foto') {
    if (!src || !String(src).startsWith('data:')) return Promise.resolve(src || null);
    if (_subidas.has(src)) return _subidas.get(src);
    const p = (async () => {
        const blob = await (await fetch(src)).blob();
        const fd = new FormData();
        fd.append('file', blob, `${prefijo}_${Date.now()}_${Math.round(Math.random() * 1e4)}.jpg`);
        const r = await api.post('/uploads', fd);
        return r.data?.url || r.data?.filename || null;
    })();
    _subidas.set(src, p);
    p.then(n => { if (!n) _subidas.delete(src); }, () => _subidas.delete(src));
    return p;
}

// Cuántas fotos de estos equipos todavía no están subidas (para la barra de progreso)
export const fotosPorSubir = (items) => (items || []).reduce((n, it) =>
    n + [it?.fotoAntes, it?.fotoDespues, ...(it?.fotosExtra || []).slice(0, 2)]
        .filter(f => f && String(f).startsWith('data:')).length, 0);

// Empieza a subir las fotos de un equipo sin esperar (segundo plano)
export function precargarFotosEquipo(it, prefijo = 'equipo') {
    subirFotosEquipo(it, prefijo).catch(() => {});
}

// Fotos del trabajo (14-oct-2026): sube las nuevas y devuelve { fotos, fallaron }
export async function subirFotosTrabajo(lista, prefijo = 'trabajo') {
    let fallaron = 0;
    const fotos = [];
    for (const f of lista || []) {
        try { const n = await subirFoto(f, prefijo); if (n) fotos.push(n); else fallaron++; }
        catch { fallaron++; }
    }
    return { fotos, fallaron };
}

// Fotos de un equipo (14-oct-2026): antes, después y hasta 2 más, todas en paralelo.
// Devuelve los campos listos para el backend ({ fotoAntes, fotoDespues, fotosExtra }) y cuántas fallaron;
// la que falla se deja afuera (se puede sumar después desde la ficha del trabajo).
export async function subirFotosEquipo(it, prefijo = 'equipo', onFoto = null) {
    let fallaron = 0;
    const una = async (src, p) => {
        if (!src) return null;
        const nueva = String(src).startsWith('data:');
        try { const n = await subirFoto(src, p); if (!n) fallaron++; return n; }
        catch { fallaron++; return null; }
        finally { if (nueva && onFoto) onFoto(); }
    };
    const extrasAntes = (it?.fotosExtra || []).slice(0, 2);
    const [fotoAntes, fotoDespues, ...extra] = await Promise.all([
        una(it?.fotoAntes, `antes_${prefijo}`),
        una(it?.fotoDespues, `despues_${prefijo}`),
        ...extrasAntes.map((f, i) => una(f, `foto${i + 3}_${prefijo}`)),
    ]);
    // El rótulo de cada foto viaja con ella (18-oct-2026)
    return { fotoAntes, fotoDespues, fotosExtra: extra.filter(Boolean), fotosRotulos: rotulosTrasSubir(it?.fotosRotulos, extrasAntes, extra), fallaron };
}

// Varios equipos a la vez (un cierre con 7 equipos sube las 28 fotos en paralelo, de a 2 equipos)
export async function subirFotosEquipos(items, prefijo = (it, i) => `eq${i}`, onFoto = null) {
    const out = [];
    for (let i = 0; i < items.length; i += 2) {
        out.push(...await Promise.all(items.slice(i, i + 2).map((it, k) => subirFotosEquipo(it, prefijo(it, i + k), onFoto)))); // eslint-disable-line no-await-in-loop
    }
    return { fotos: out, fallaron: out.reduce((n, r) => n + r.fallaron, 0) };
}
